var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.status === 'done')?_c('a-badge',{attrs:{"status":"default","text":"已结束"}}):(_vm.status === 'ing')?_c('a-badge',{attrs:{"status":"processing","text":"进行中"}}):(_vm.status === 'not-start')?_c('a-badge',{attrs:{"status":"warning","text":"未开始"}}):_c('span')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }